import { CACHED_USER_KEY } from 'utils/appConstants';
import {
  MFA_SUCCESS,
  MFA_FAIL,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  REFRESH_AUTHENTICATED_USER_INFO_SUCCESS,
  REFRESH_AUTHENTICATED_USER_INFO_FAIL,
  SET_AUTHENTICATED_USER_INFO_SUCCESS,
  SET_AUTHENTICATED_USER_INFO_FAIL,
  EDIT_ACCOUNT_INFO_SUCCESS,
  LOGOUT_SUCCESS,
  LOGOUT_FAIL
} from './actions';

const initialState = {
  authenticatedUser: null,
  userToken: null,
  cancelMfaError: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case MFA_SUCCESS:
    case LOGIN_SUCCESS:
    case REFRESH_AUTHENTICATED_USER_INFO_SUCCESS:
      const userToken = action.data.userToken;
      localStorage.setItem(CACHED_USER_KEY, userToken);
      return {
        ...state,
        authenticatedUser: action.data.user,
        userToken: userToken
      };

    case EDIT_ACCOUNT_INFO_SUCCESS:
    case SET_AUTHENTICATED_USER_INFO_SUCCESS:
      return {
        ...state,
        authenticatedUser: action.data
      };
    case LOGIN_FAIL:
    case MFA_FAIL:
    case REFRESH_AUTHENTICATED_USER_INFO_FAIL:
    case SET_AUTHENTICATED_USER_INFO_FAIL:
    case LOGOUT_SUCCESS:
    case LOGOUT_FAIL:
      localStorage.removeItem(CACHED_USER_KEY);
      return {
        ...state,
        authenticatedUser: null,
        userToken: null
      };
    default:
      return state;
  }
};

export default reducer;
